// src/components/Footer.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import pccmlogo from "../assets/pccm_logo.png";
import "../styles/Footer.css";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footer-grid">
          
          <div className="footer-brand">
            <img src={pccmlogo} alt="PCCM" className="footer-logo" />
            <h3>Philippine Canadian Centre of Manitoba</h3>
            <p className="address">
              737 Keewatin St<br />
              Winnipeg, MB R2X 3B9<br />
              (204) 775-4928
            </p>
          </div>

          <div className="footer-links">
            <h4>Organization</h4>
            <ul>
              <li><NavLink to="/aboutus">About Us</NavLink></li>
              <li><NavLink to="/constitution">Constitution</NavLink></li>
              <li><NavLink to="/report">Finance</NavLink></li>
              <li><NavLink to="/memberships">Memberships</NavLink></li>
            </ul>
          </div>

          <div className="footer-links">
            <h4>Community</h4>
            <ul>
              <li><NavLink to="/news">News</NavLink></li>
              <li><NavLink to="/events">Events</NavLink></li>
              <li><NavLink to="/gallery">Gallery</NavLink></li>
              <li><NavLink to="/spaces">Rental Spaces</NavLink></li>
            </ul>
          </div>

          <div className="footer-connect">
            <h4>Connect</h4>
            <div className="social-links">
              <a href="https://www.facebook.com/groups/3555107267913403/" target="_blank" rel="noreferrer">Facebook</a>
              <a href="https://thenewpccm.substack.com/" target="_blank" rel="noreferrer">Substack</a>
            </div>
            <NavLink to="/contact" className="btn btn-outline btn-sm footer-btn">Contact Us</NavLink>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {year} PCCM. All rights reserved.</p>
          <div className="legal">
            <span>Privacy Policy</span>
            <span>Terms & Conditions</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
